module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAATCAYAAABGKffQAAAA2klEQVR42mJcvXo1AxYwCYhXAfERZEEmLArtgTgHiOcBMSc+xdxAPBeIGYFYFYhb8CluBWJlJH4+EFtiU2wDxLlompmhzuFAVswJFcTmBw0gbkRW3AJ1Iy5QDMRmLFCdvkB8jwE/qAEpvgHEagxEAEbtxe8ZiAUsUJ9yEqtYGogvQiMEH9gFCo27QFxNQOFnIE6FBd1k9ESDBkqB+BFM8T8gTgLi71gU7gXiWejRfRsUllisBxnyH1tCmgjEx9Gtx5Xq/kJN+oFsPXLQoQNQjJYA8TaY9TAAEGAANxAoewK/Hv0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.png
// module id = lP78
// module chunks = 1